import { render } from "./ManualPage.vue?vue&type=template&id=4f4cf55a&scoped=true"
import script from "./ManualPage.vue?vue&type=script&lang=js"
export * from "./ManualPage.vue?vue&type=script&lang=js"

import "./ManualPage.vue?vue&type=style&index=0&id=4f4cf55a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4cf55a"]])

export default __exports__